/**
 * Quick-reply options: the agent ends a message with `[[suggestions: A | B | C]]` and the chat
 * renders those as clickable buttons, stripping the marker from the visible text.
 */
export const SUGGESTIONS_RE = /\[\[suggestions:\s*([^\]]*)\]\]/i;

export function parseSuggestions(content: string): { text: string; suggestions: string[] } {
  const match = content.match(SUGGESTIONS_RE);
  if (!match) return { text: content, suggestions: [] };
  const suggestions = match[1]
    .split('|')
    .map((s) => s.trim())
    .filter(Boolean);
  const text = content.replace(SUGGESTIONS_RE, '').trimEnd();
  return { text, suggestions };
}

/** While streaming, hide a complete or still-being-typed suggestions marker from the visible text. */
export function stripStreamingSuggestions(content: string): string {
  return content
    .replace(SUGGESTIONS_RE, '')
    .replace(/\[\[suggestions:[^\]]*$/i, '')
    .trimEnd();
}
